<template>
    <div class="excavate-KM">
        <div class="KM-thought">
            <p>聚类的基本思想是"物以类聚、人以群分"，将大量数据集中相似的数据样本区分出来，并发现不同类的特征。聚类模型可以建立在无类标记的数据上，是一种非监督的学习算法。</p>
            <p>k均值聚类算法（k-means clustering algorithm是最基础常用的聚类算法。它的基本思想是，通过迭代寻找K个簇（Cluster）的一种划分方案，使得聚类结果对应的损失函数最小。其中，损失函数可以定义为各个样本距离所属簇中心点的误差平方和。</p>
            <p>其步骤是：</p>
            <ul>
                <li>（1）预将数据分为K组，则随机选取K个对象作为初始的聚类中心。</li>
                <li>（2）计算每个对象与各个种子聚类中心之间的距离，把每个对象分配给距离它最近的聚类中心</li>
                <li>（3）重新计算每个类的中心。</li>
                <li>（4）重复步骤（2）、（3），直到聚类结果不再发生变化。</li>
            </ul>
        </div>
        <div class="KM-search flex">
            <el-form  class="search-form">
                <el-form-item label="筛选前" :label-width="labelWidth">
                    <el-input class="search-num" :min="1" type='number' size='mini' v-model='topValue'></el-input>个进行聚类
                </el-form-item>
                <el-form-item label="类型：" :label-width="labelWidth">
                    <el-radio-group v-removeAriaHidden v-model="searchType" >
                        <el-radio @change="changeRadin" v-for="(item,index) in searchRadio" :key="index" :label="item.label">{{item.value}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" size="small" @click="analysis">开始分析</el-button>
            </div>
        </div>
        <clusterTable ref='cluster_table'></clusterTable>
        <!-- 开始分析计算出的图 -->
        <div>
            <!-- 加载load -->
            <div v-show='analysis_isLoad' class="loading"></div>
            <div v-show='isShowAnalysis&&!analysis_isLoad' >
                <KMAnalysis ref='KM_analysis' id='KMAnalysis'></KMAnalysis>
                <div class="flex">
                    <el-form  class="search-form" id="kValue">
                        <el-form-item label="K值：" :label-width="labelWidth">
                            <el-input class="search-num"  :min="1" type='number' size='mini' v-model='kValue'></el-input>
                        </el-form-item>
                        <el-form-item label="是否显示节点名称：" label-width="140px">
                            <el-radio-group v-removeAriaHidden v-model="show_nodeName" >
                                <el-radio label="1">是</el-radio>
                                <el-radio label="0">否</el-radio>
                            </el-radio-group>
                            <el-button type="primary" size="small" @click="kmeans_Cu">聚类分析</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="pic-tip" v-if="isShowK_analysis" >
                        <el-button type="primary"  size="small" @click="report_clik">生成报告</el-button>
                        <el-button type="primary" size="small" @click="save_pic" >保存图片</el-button>
                        <span class="tip">*图片可点击放大</span> 
                    </div>
                </div>
                <!-- <div v-if="k_isLoad" class="loading">加载中～</div> -->
                
            </div>
         </div>
         <!-- 聚类分析计算出的数据 -->
         <div>
            <!-- 加载load -->
            <div v-if='k_isLoad' class="loading"></div>
            <div  v-else-if="isShowK_analysis&&!k_isLoad">
                <div class="analysis-pic">
                    <div v-if="cluster_url==''" slot="error" class="load-img">
                        <!-- <i class="el-icon-picture-outline"></i> -->
                        图片加载中～
                    </div>
                    <el-image 
                        v-else
                        width="100%"
                        :src="cluster_url" 
                        ref="clusterUrl"
                        :preview-src-list="cluster_srcList">
                    </el-image>
                </div>
                <analysisTable></analysisTable>
            </div>
         </div>
         
        <!-- 生成报告 -->
        <reportModel  :ok="'确定'" :cancel="'取消'" :show.sync='isShowReport' :titleName='`${eTitle}-K-Means聚类`' :reportList='cluster_table' :reportImg='reportImg'></reportModel>
        <!-- <modelTip :ok="'确定'" :cancel="'取消'" :show.sync='isShowReport' @ok='report_sure' :width="'450px'" :title="'生成报告'">
            <div slot="content" >
                <el-form class="form-data">
                    <el-form-item label="文件名称："  label-width="90px">
                        <el-input v-model="reportName"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </modelTip> -->
        <!-- 聚类分析 错误提示-->
        <modelTip :ok="'确定'" :show.sync='isShowTip' @ok='tip_sure' :width="'400px'" :title="'提示'">
            <div slot="content" >
                <p>{{tipMsg}}</p>
            </div>
        </modelTip>
    </div>
</template>

<script>
import { mapState,mapMutations, mapActions } from 'vuex';

import reportModel from './comps/report_model.vue'
import {getPinCi,kmeansZheXian,kmeansCu,createExport} from '../../io/api.js'
import clusterTable from './K_Means/cluster_table.vue';
import modelTip from '../../components/ui-kit/model_tip.vue'
import analysisTable from './K_Means/analysis_table.vue';
import KMAnalysis  from './K_Means/KM_analysis.vue'
import saveImg from '../../utils/saveImg.js'
export default {
    components: {
        clusterTable,  
        modelTip,
        reportModel,
        KMAnalysis,
        analysisTable,
    },
    data () {
        return {
            labelWidth:'60px',
            topValue:'',
            kValue:'',
            searchType:'HERB',
            show_nodeName:'0',
            // analysis_url:'',
            // analysis_srcList:[],
            eTitle:'',
            searchRadio:[
                {
                    value:'中药',
                    label:'HERB'
                },
                {
                    value:'症状',
                    label:'SYMP'
                },
                {
                    value:'穴位',
                    label:'XW'
                },
                {
                    value:'证素',
                    label:'ZS'
                },
                {
                    value:'证侯',
                    label:'ZH'
                }
            ],
            analysis_isLoad:false,
            k_isLoad:false,
            isShowAnalysis:false,
            isShowK_analysis:false,
            isShowReport:false,
            isShowTip:false,
            tipMsg:'',
            reportName:'',
            reportImg:'',
            
        }
    },
    computed: {
        ...mapState({
            // k_isLoad:state=>state.excavate.k_isLoad,

            cluster_table:state=>state.excavate.cluster_table,
            cluster_url:state=>state.excavate.cluster_url,
            cluster_srcList:state=>state.excavate.cluster_srcList,
            k_table:state=>state.excavate.k_table,
            analysis_url:state=>state.excavate.analysis_url,
            analysis_srcList:state=>state.excavate.analysis_srcList,
        })
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        ...mapMutations(['setKTable','setCluster_table','setKIsLoad','setCluster_url','setAnalysis_url']),
        ...mapActions(['saveExport']),
        getInfo(){
            getPinCi({type:this.searchType}).then((res)=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.setKTable(data.data)
                    this.$refs.cluster_table.clearSort()
                    this.$refs.cluster_table.changePage(1)
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
            })
        },
        // 初始化数据
        init_kmeans(){
            this.analysis_isLoad=true;
            this.isShowK_analysis = false;
            this.kValue='';
            this.reportName='';
            this.show_nodeName='0';
            this.setAnalysis_url();
            this.setCluster_url();
        },
        changeRadin(val){
            this.searchType = val;
            this.getInfo();
        },
        analysis(){
            if(this.topValue==''){
                this.$message.error('请筛选数据~');
                return
            }
            let params={
                topValue:this.topValue,
                type:this.searchType,
            }
            this.init_kmeans();
            // 聚类分析不显示
            kmeansZheXian(params).then((res)=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.isShowAnalysis = true;
                    this.setAnalysis_url(data.data);
                    setTimeout(() => { 
                        this.getlocal('KMAnalysis')
                    }, 200);
                }else{
                     this.isShowTip = true;
                    this.isShowAnalysis = false;
                    this.tipMsg=data.msg||'请求失败～'
                }
                this.analysis_isLoad=false
            })
        },
        //锚点定位
        getlocal(id) { 
			//找到锚点id  
			let toElement = document.getElementById(id); 
			//如果对应id存在，就跳转 
			if (id) {   
				toElement.scrollIntoView({ behavior: 'smooth' }); 
			} 
		}, 
        // 聚类分析
        kmeans_Cu(){
            if(this.kValue==''){
                this.$message.error('请筛选数据~');
                return
            }
            let params={
                kValue:this.kValue,
                jieDian:this.show_nodeName,
            }
            if(this.show_nodeName!=0){
                delete params.jieDian
            }
            this.k_isLoad=true
            this.setCluster_url();
            kmeansCu(params).then((res)=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.isShowK_analysis = true;
                    this.setCluster_table(data.data.cuTable);
                    this.setCluster_url(data.data.img) 
                    setTimeout(() => { 
                        this.getlocal('kValue')
                    }, 200);
                }else{
                    this.isShowTip = true;
                    this.isShowK_analysis = false;
                    this.tipMsg=data.msg||'请求失败～'
                    // this.$message.error(data.msg||'请求失败～')
                }
                this.k_isLoad=false
                // this.setKIsLoad(false);
            })
        },
        // 聚类分析 错误提示
        tip_sure(){
            this.isShowTip = false;
        },

        save_pic(){
            saveImg(this.$refs.clusterUrl.src,new Date().getTime())
        },
        // 生成报告
        report_clik(){
            this.isShowReport = true;
            let eImg=this.analysis_srcList.concat(this.cluster_srcList);
            this.reportImg=JSON.stringify(eImg)
            this.searchRadio.forEach(item => {
                if(item.label==this.searchType){
                    this.eTitle = item.value
                }
            });
        },
        // report_sure(){
        //     if(this.reportName==''){
        //         this.$message.error('请输入文件名称');
        //         return
        //     }
        //     this.searchRadio.forEach(item => {
        //         if(item.label==this.searchType){
        //             this.eTitle = item.value
        //         }
        //     });
        //     let eImg=this.analysis_srcList.concat(this.cluster_srcList);
        //     let params={
        //         fileName:this.reportName,
        //         img:JSON.stringify(eImg),
        //         title:`${this.eTitle}-K-Means聚类`,
        //         list:JSON.stringify(this.k_table),
        //     }
        //     this.saveExport({params,cb: res => {
        //         if(res){
        //             this.isShowReport = false;
        //             if(res.code==0){
        //                  this.$message({
        //                     message:'保存成功',
        //                     type: 'success'
        //                 });
        //             }else{
        //                 this.$message.error(data.msg||'请求失败～')
        //             }
        //         }
        //      } })
        // },
    }
}
</script>

<style>

</style>